import {Component, OnInit, ViewChild} from "@angular/core";
import {Upload} from "../../../../dto/upload";
import {DateFormats} from "../../../../providers/app-date-adapter";
import {ContentRowField} from "../../../../shared/content-row/content-row.component";
import {DatePipe, Location} from "@angular/common";
import {ActivatedRoute, Params} from "@angular/router";
import {ReadonlyDataSource} from "../../../../table-datasouces/readonly.datasource";
import {UploadsAdminService} from "../../../services/uploads-admin.service";

import {MatTableGeneratorComponent} from "../../../../shared/mat-table-generator/mat-table-generator.component";

@Component({
  selector: 'app-image-album',
  templateUrl: './image-album.component.html',
  styleUrls: ['./image-album.component.css']
})
export class ImageAlbumComponent implements OnInit {
  dataSource = new ReadonlyDataSource<Upload>(this.uploadsAdminService);

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  columns = [
    { columnDef: 'id', header: 'Id',           cell: row => `${row.id}`},
    { columnDef: 'uploadDate', header: 'Date',         cell: row => `${this.datePipe.transform(row.uploadDate, DateFormats.DisplayDate)}`},
    { columnDef: 'originalFileName', header: 'Original Name',         cell: row => row.originalFileName},
    { columnDef: 'fileName', header: 'Name',         cell: row => row.fileName},
    { columnDef: 'fileSize', header: 'Size',         cell: row => this.getHumanReadableFileSize(row.fileSize)},
    { columnDef: 'contentType', header: 'Type',         cell: row => this.getFriendlyContentType(row.contentType)},
  ] as ContentRowField<Upload>[];
  getViewLink = (item: Upload): string => 'file/' + item.fileName;
  albumId: string;
  getEditLink: (row: any) => null;
  getRowClass = (item: any): string => {
    const classes = [];

    // TODO implement this if necessary
    return classes.join(' ');
  };


  constructor(
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private uploadsAdminService: UploadsAdminService,
    private location: Location,

  ) {

  }

  returnBack() {
    this.location.back();
  }

  contentTypes: Record<string, string> = {
    "text/html": "HTML Document",
    "application/json": "JSON Data",
    "text/plain": "Plain Text",
    "text/css": "CSS Stylesheet",
    "text/javascript": "JavaScript File",
    "application/javascript": "JavaScript File",
    "application/xml": "XML Document",
    "application/pdf": "PDF Document",
    "image/jpeg": "JPEG Image",
    "image/png": "PNG Image",
    "image/gif": "GIF Image",
    "audio/mpeg": "MP3 Audio",
    "audio/wav": "WAV Audio",
    "video/mp4": "MP4 Video",
    "video/webm": "WebM Video",
    "application/zip": "ZIP Archive",
    "application/vnd.ms-excel": "Excel Spreadsheet",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel Spreadsheet",
    "application/msword": "Word Document",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word Document",
    "application/vnd.ms-powerpoint": "PowerPoint Presentation",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PowerPoint Presentation"
  };

  getFriendlyContentType(contentType: string): string {

    return this.contentTypes[contentType] || contentType;
  }



  getHumanReadableFileSize(fileSize: number) {
    const units = ["", "KB", "MB", "GB", "TB"];
    let index = 0;

    while (fileSize >= 1024 && index < units.length - 1) {
      fileSize /= 1024;
      index++;
    }

    return `${fileSize.toFixed(2)} ${units[index]}`;
  }

  ngOnInit(): void {

    this.route.params.subscribe((params: Params) => {
      this.albumId = params['albumId'];
      this.table.filters.someAdditionalData = this.albumId;
    });
  }

  editEnabled() {
    return false;
  }

  deleteEnabled() {
    return false;
  }

  clearFilter() {
    this.table.clearFilter(true);
  }

  onSearch() {
    this.table.filters.someAdditionalData = this.albumId;
    this.table.applyFilter();
  }

  uploadFile($event) {
    const file = $event.target.files[ 0 ];
    const fileName = file != null ? file.name : null;
    const albumId = this.albumId;

    this.uploadsAdminService.uploadFile( file, albumId ).subscribe( result => {
      this.table.applyFilter();
    } );
  }
}
